<template>
  <div class="fs-adjustments">
    <fs-range-filter-wrapper min="-1" max="1" defaultValue="0" :routerLink="'/adjustments'" v-model="value.contrast" label="menu.contrast"/>
  </div>
</template>

<script lang="ts">
import { Adjustments } from '@filestack/canvas-sdk';
import { Component } from 'vue-property-decorator';
import { FilterMixin } from './FilterMixin';

@Component
class Contrast extends FilterMixin {

  protected filter = new Adjustments.Contrast();

  protected value = { contrast: 0 };
}

export default Contrast;
</script>

